module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"page.title":"{name} :: ข้อมูล Drone","page.title.search":"ค้นหา Drone","search.input.label":"S/N","search.input.placeholder":"ระบุ S/N ของ Drone"}}')
  delete Component.options._Ctor
}
